import NavSection from './components/Navbar';

import Routing from './components/Routing';
import './styles/global.css'

function App() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
     
       <NavSection /> 
   
     <Routing />
 
    </div>
  );
}

export default App;
